import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled from '@emotion/styled'
import { selectMessages, useAppSelector } from '@open-tender/cloud'
import Alert from './Alert'

const AlertsView = styled.div`
  position: fixed;
  z-index: 15;
  top: ${(props) => props.theme.layout.navHeight};
  right: ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    right: ${(props) => props.theme.layout.paddingMobile};
  }
`

const Alerts = () => {
  const messages = useAppSelector(selectMessages)

  return (
    <AlertsView>
      <TransitionGroup component={'ul'}>
        {messages?.map((message) => (
          <CSSTransition
            key={message.id}
            classNames="flash-message"
            timeout={500}
          >
            <Alert {...message} />
          </CSSTransition>
        ))}
      </TransitionGroup>
    </AlertsView>
  )
}

export default Alerts
